export enum VDRFileSourceType {
    DataRequest = 0,
    VDR = 1,
}

